import { AbstractControl, Validators, ValidatorFn } from '@angular/forms';

import { isPresent } from '../lang';

export const max = (maxNumber: number): ValidatorFn => {
  return (control: AbstractControl): {[key: string]: any} => {
      if (!isPresent(maxNumber)) { return null; }
      if (isPresent(Validators.required(control))) { return null; }

    let v: number = +control.value;
    return v <= +maxNumber ? null : {actualValue: v, requiredValue: +maxNumber, max: true};
  };
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/utilities/maxNumber-validator/validator.ts